import React, { useEffect } from "react";
import { Col, Container, Row, Button, FormGroup} from "react-bootstrap";
import { Input, Form} from 'antd';
import { AuthHeader, ImageElement, MainHeader } from "../../components";
function Resetpassword() {
    useEffect(() => {
        let navbar = document.querySelector(".header");
        let navbarHeight = navbar?.clientHeight;
        let authPage = document.querySelector(".authPage_inner");
        if(authPage){
        authPage.style.minHeight = `${window.innerHeight - navbarHeight}px`;
        }
    });
    return (
        <>
            <AuthHeader/>
            <main className="authPage">
                <div className="authPage_inner d-flex flex-column justify-content-center align-items-center">
                    <Container>
                        <Row className="g-0 align-items-center">
                            <Col xxl="6" lg="5" className="d-none d-lg-block">
                                <div className="authPage_left">
                                    <ImageElement source="auth-img.png" className="img-fluid"/>
                                </div>
                            </Col>
                            <Col xxl="6" lg="7">
                                <div className="authPage_right rstPd w-100 ms-auto">
                                    <div className="authPage_top w-100 mx-auto">
                                        <h1 className="authPage_top_title mb-0 text-center">Reset Password</h1>
                                        <div className="authPage_top_img mx-auto">
                                            <ImageElement source="profile-img.png"/>
                                        </div>
                                        <p className="mb-0 text-center">Hey, Nikola Laringo</p>
                                        <div className="authPage_top_login">
                                            <Form>          
                                                <FormGroup className="form-group">
                                                    <label className="ant-label w-100">Password</label>
                                                    <Input.Password size="large" placeholder="Password" iconRender={visible => (visible ? <div><em className="gg-eye-on"/></div> : <div><em className="gg-eye-off"/></div>)}/>
                                                </FormGroup>
                                                <FormGroup className="form-group mb-0">
                                                    <label className="ant-label w-100">Confirm Password</label>
                                                    <Input.Password size="large" placeholder="Confirm Password" iconRender={visible => (visible ? <div><em className="gg-eye-on"/></div> : <div><em className="gg-eye-off"/></div>)}/>
                                                </FormGroup>
                                                <div className="authPage_top_reset">
                                                    <Button variant="primary" size="lg" className="w-100 " type="submit">Submit</Button>
                                                </div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </main>
        </>
    );
  }
  
  export default Resetpassword;